import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom';

const Footer = () => {

    return (
        <footer>
            <div className="flex">

                <img src="favicon.png" alt="Inifits Logo" />
                <p>&copy; 2023 INIFITS. All rights reserved.</p>
            </div>
            <div className="socials">
                {/* <a href="https://www.facebook.com/inifits" target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-facebook-f"></i></a> */}
                <a href="https://www.instagram.com/inifitspk/" target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-instagram"></i></a>
                {/* <a href="https://www.linkedin.com/company/inifits/" target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-linkedin-in"></i></a> */}
                {/* <a href="https://twitter.com/inifits" target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-twitter"></i></a> */}
            </div>
            <div className="con">

                <div className="links">
                    <Link to='/' className='Link' style={{ textDecoration: 'none'}}>
                        Home
                    </Link>
                    <Link to='/Products' className='Link' style={{ textDecoration: 'none'}}>
                        Products
                    </Link>
                    <Link to='/collections' className='Link' style={{ textDecoration: 'none' }}>
                        Collections
                    </Link>


                </div>
                <div className="links">
                    <Link to='/About-us' className='Link' style={{ textDecoration: 'none' }}>
                        About Us
                    </Link>
                    <Link to='/Contact-us' className='Link' style={{ textDecoration: 'none' }}>
                        Contact Us
                    </Link>
                    <Link to='/track' className='Link' style={{ textDecoration: 'none'}}>
                        Track Order
                    </Link>


                </div>
            </div>
        </footer>
    );
};

export default Footer;